<template>
    <main-content>
        <div class="shadow-sm bg-white rounded p-4">
            <charge-form :form_data="form_data"
                         :form_meta_data="form_meta_data"
                         :on_submit="chargeByOauth"
            >
            </charge-form>
        </div>
    </main-content>
</template>

<script>
    import ChargeForm from './components/charge-by-oauth-form';
    import mainContent from '@/components/main-content';
    import {i18n} from '@/plugins/i18n';
    import $ from 'jquery';
    import {walletService} from '@/common/api.service';
    import {KTApp} from '@/plugins/core/app'

    export default {
        components: {
            ChargeForm,
            mainContent,
        },
        data() {
            return {
                form_data: {
                    amount: '',
                },
                form_meta_data: {
                    submit_btn_progress: false,
                    submit_btn_text: i18n.t('wallets.label.charge'),
                },
            };
        },
        methods: {
            chargeByOauth() {
                let form = $('#submit_form');
                let btn = $('#chargeByOauthBtn');
                form.validate({
                    rules: {
                        amount: {
                            required: true,
                        },
                        iban_number: {
                            required: this.form_data.bank === '019',
                        },
                    }
                });

                if (!form.valid()) {
                    return;
                }

                this.form_meta_data.submit_btn_progress = true;

                let params = {
                    amount: this.form_data.amount.replace(/,/g, ''),
                    iban_number: this.form_data.iban_number,
                };

                if (params.amount <= 100000)
                    return  this.toastr.error(i18n.t('wallets.error.min_charge'));

                btn.prop("disabled", true);
                btn.html(`<div class="d-flex justify-content-center align-items-center"><div class="px-2">لطفا صبر کنید</div><div class="spinner-border spinner-border-sm text-white" role="status"></div></div>`);

                if (this.form_data.bank_id === '062') {//ayande
                    walletService.chargeByOauthAyande(params, this.$route.params.hashid).then(response => {
                        window.location = response.data.data.oauth_url;
                    }).catch(({response}) => {
                        if (response.data) {
                            form.validate().showErrors(response.data.data);
                        }

                        this.showMsg(form, 'danger', response.data.message);
                    }).finally(() => {
                        this.form_meta_data.submit_btn_progress = false;
                        btn.prop("disabled", false);
                        btn.html(this.$t('wallets.label.charge'));
                    });
                } else if (this.form_data.bank_id === '019') {//saderat
                    walletService.chargeBySaderat(params, this.$route.params.hashid).then(response => {
                        this.showMsg(form, 'success', response.data.message);
                    }).catch(({response}) => {
                        if (response.data) {
                            form.validate().showErrors(response.data.data);
                        }

                        this.showMsg(form, 'danger', response.data.message);
                    }).finally(() => {
                        this.form_meta_data.submit_btn_progress = false;
                        btn.prop("disabled", false);
                        btn.html(this.$t('wallets.label.charge'));
                    });
                } else if (this.form_data.bank_id === '056') { //saman
                    walletService.chargeBySaman(params, this.$route.params.hashid).then(response => {
                        this.showMsg(form, 'success', response.data.message);
                    }).catch(({response}) => {
                        if (response.data) {
                            form.validate().showErrors(response.data.data);
                        }

                        this.showMsg(form, 'danger', response.data.message);
                    }).finally(() => {
                        this.form_meta_data.submit_btn_progress = false;
                        btn.prop("disabled", false);
                        btn.html(this.$t('wallets.label.charge'));
                    });
                }
            },
        },
    }
</script>
